<template>
  <table class="table w-100">
    <thead>
      <tr>
        <th>Plan</th>
        <th>Member Details</th>
        <th>Date</th>
        <th>Created/Submitted By</th>
        <th>Claim Status</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td v-if="claimList.records.length < 1" colspan="6" align="center">
          No records found.
        </td>
      </tr>
      <tr v-for="(claim, index) in claimList.records" :key="index">
        <td>{{ claim.plan_overview.plan_name }}</td>

        <td>
          <strong
            >{{ claim.user_info_policy_address.member_name }}
            {{ claim.user_info_policy_address.member_lname }}</strong
          >
          <br />
          <span class="claim-email">
            {{ claim.user_info_policy_address.member_email }}
            <b-badge
            pill
            :style="{
              backgroundColor: statusClass(claim?.email_delivery_status),
            }"
          >
            {{
              claim?.email_delivery_status ? claim.email_delivery_status : "N/A"
            }}
          </b-badge>
          </span>
        </td>

        <td>
          <strong>Added: </strong> {{ formatDate(claim.created_at) }}
          <br />
          <span v-if="claim.submitted_at">
            <strong>Submitted: </strong>
            {{ formatDate(claim.submitted_at) }}
          </span>
        </td>
       
        <td>
          <div>
            <strong>Created:</strong>
            <span v-if="claim.claim_by_type.toLowerCase() === 'rep'">
              {{ claim.claim_by_type }} ({{ claim.claim_by_rep_name }})
            </span>
            <span v-else>
              {{ claim.claim_by_type }}
            </span>
          </div>
          <div v-if="claim.submitted_by">
            <strong>Submitted:</strong>
            <span v-if="claim.submitted_by.toLowerCase() === 'rep'">
              {{ claim.submitted_by }} ({{ claim.submitted_by_rep_name }})
            </span>
            <span v-else>
              {{ claim.submitted_by || "-" }}
            </span>
          </div>
        </td>
       
        <td :class="claim?.status?.toLowerCase()">
          <span>{{
            claim?.status?.charAt(0).toUpperCase() + claim?.status?.slice(1)
          }}</span>
        </td>
        <td class="d-flex align-items-center action-icons">
          <custom-button
            v-if="
              claim.status.toLowerCase() === 'submitted' ||
              claim.status.toLowerCase() !== 'submitted'
            "
            :title="
              claim.status.toLowerCase() === 'submitted'
                ? 'View File'
                : 'Edit File'
            "
            iconClass="fas fa-eye"
            @onClicked="onViewFile(claim)"
          />
          <custom-button
            v-if="claim.status.toLowerCase() === 'pending'"
            title="Submit File"
            iconClass="fas fa-file-upload"
            @onClicked="onSubmitFile(claim)"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    claimList: {
      required: false,
    },
    formatDate: Function,
    statusClass: Function,
  },
  methods: {
    onViewFile(claim) {
      this.$emit("view-file", claim);
    },
    onSubmitFile(claim) {
      this.$emit("submit-file", claim);
    },
  },
};
</script>

<style>
.claim-email {
 display: flex;
 justify-content: space-between;
}
.claim-email .badge{
 margin-left: 10px;
}
</style>